
// @ts-check

import React from "react";
import DonorCard from "./DonorCard";
import LegacyDonorCard from "./LegacyDonorCard";

import { determineNumberOfColumns } from "./processQuerySpec";


/**
 * @typedef {import('./coreTypes').ResultAtom} ResultAtom
 * @typedef {import('./coreTypes').JSResultAtom} JSResultAtom
 * @typedef {import('./coreTypes').QuerySpec} QuerySpec
 */


/**
 * @param {{ donors: JSResultAtom[], singleColumn: ?boolean }} props 
 */
function DonorCardWebLayout(props) {
    
    /**
     * @param {JSResultAtom} d 
     * @param {number} i 
     * @returns {JSX.Element}
     */
    const wrapDonorCard = (d, i) => (
        <div style={{ marginLeft: 10, marginRight: 10 }}>
            {getCardForDonor(d, "i_" + i)}
        </div>);

    const donorCols = sortIntoColumns(props.donors, props.singleColumn);

    const donorCardCols = 
        donorCols.map(dc => (
            /** @ts-ignore */
            <div style={(props.singleColumn) ? donorColumnMobileStyle : donorColumnStyle}>
                {dc.map((d, i) => wrapDonorCard(d, i))}
            </div>));

    return (
        /** @ts-ignore */
        <div style={donorContainerStyle}>
            {donorCardCols}
        </div>);
}

/**
 * @param {JSResultAtom[]} donors 
 * @param {?boolean} singleColumn
 * @returns {JSResultAtom[][]}
 */
function sortIntoColumns(donors, singleColumn) {

    if (singleColumn === true) {
        return [donors];
    }

    const numOfCols = determineNumberOfColumns(window.visualViewport.width);
    
    /**
     * @type {JSResultAtom[][]}
     */
    const cols = [];
    const colWeights = [];

    for (let a = 0; a < numOfCols; a++) {
        cols.push([]);
        colWeights.push(0);
    }

    /**
     * @param {number[]} weights 
     * @returns {number}
     */
    const lowestWeightCol = (weights) => {
        let lowest = Infinity;
        let index = 0;
        for (let i = 0; i < numOfCols; i++) {
            if (weights[i] < lowest) {
                index = i;
                lowest = weights[i];
            }
        }
        return index;
    };


    let c = 0;
    for (let a = 0; a < donors.length; a++) {
        c = lowestWeightCol(colWeights);
        cols[c].push(donors[a]);
        colWeights[c] += donors[a][1].blockSize;
    }

    return cols;
}

const donorContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'flex-start',
};


const donorColumnStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignContent: 'center',
};

const donorColumnMobileStyle = {
    ...donorContainerStyle,
    gap: 15,
    flexWrap: 'wrap',
};


/**
 * @param {JSResultAtom} d 
 * @param {string} k 
 * @returns {JSX.Element | null}
 */
 function getCardForDonor(d, k) {
	switch (d[0]) {
		case 'donor': return (<DonorCard donor={d[1]} key={k} />);
		case 'donor_legacy': return (<LegacyDonorCard donor={d[1]} key={k} />);
		default: return null;
	}
}

export default DonorCardWebLayout;